import styled from 'styled-components';
import { Flex } from '../../../../GlobalComponents/Flex';

const DetailTitleContainer = styled(Flex)`
	flex-direction: column;
	column-gap: 12px;
	align-items: flex-start;

	@media (max-width: 340px) {
		flex-direction: column;
		align-items: unset;
		row-gap: 4px;
	}
`;

const DetailTitle = styled.h1`
	color: #f47920;
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 0;
`;

const TextTeal = styled.h2`
	color: #f47920;
	margin-bottom: 0;
	font-size: 20px;
`;

const DetailDivider = styled.div`
	border-bottom: solid 2px;
	height: 3px;
	border-color: rgba(117, 117, 117, 0.25);
	width: 100%;
`;

const DetailContainer = styled.div`
	margin-bottom: 24px;
	padding: 0 0 24px 0;
	display: flex;
	flex-direction: column;
	row-gap: 24px;
	width: 100%;
`;

const DetailInlineFlex = styled.div`
	display: inline-flex;
`;

const DetailLeft = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
`;

const DetailRight = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	width: 100;
`;

const TotalOrangeText = styled.h2`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	color: #f47920;
	line-height: 60%;
`;

const TotalAmount = styled.h2`
	color: black;
	font-weight: 700;
	line-height: 60%;
`;

const SubTotalHeader = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	color: black;
`;

const SubTotalAmount = styled.div`
	color: black;
	line-height: 60%;
	display: flex;
	align-items: flex-start;
`;

const DetailItemLeft = styled.div`
	display: flex;
	align-items: flex-start;
	margin-right: 1rem;
`;

const DetailItemContainer = styled.div`
	display: flex;
	flex-direction: row;
	padding: 0;
`;

const DetailPriceRight = styled.p`
	display: flex;
	align-items: flex-start;
	margin-top: auto;
	margin-bottom: auto;
`;

const DetailLeftRight = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-right: 8px;
`;

const DetailItemModifiers = styled.p`
	margin-top: 0;
	padding: 0;
	font-size: 14px;
	width: 100%;
`;

const DetailItemTitle = styled.p`
	margin-bottom: 0.5rem;
	color: #fd7e14;
	font-weight: 600;
	margin-top: 0;
	padding: 0;
	font-size: 20px;
	width: 100%;
`;

export {
	DetailTitleContainer,
	DetailItemTitle,
	DetailItemModifiers,
	DetailItemContainer,
	DetailLeftRight,
	DetailPriceRight,
	DetailTitle,
	DetailDivider,
	DetailContainer,
	TextTeal,
	DetailLeft,
	DetailRight,
	DetailInlineFlex,
	TotalOrangeText,
	SubTotalHeader,
	SubTotalAmount,
	TotalAmount,
	DetailItemLeft
};
